<template>
  <div id="external-contact-update" class="row" v-if="detail.id">
    <form id="update-external-contact-form" class="small-12 medium-5 columns" @submit.prevent="submitForm">
      <label>
        {{ 'Contact'|t }}
        <input type="text" :value="contact_cid" disabled />
      </label>

      <label>
        {{ 'ID'|t }}
        <input type="text" :value="external_id" disabled />
      </label>

      <label>
        {{ 'Object type'|t }}
        <input type="number" step="1" v-model="object_type" required="required" />
      </label>

      <label>
        {{ 'Value Added Tax'|t }}
        <input type="text" v-model="vat" />
      </label>

      <label>
        {{ 'Add information'|t }}
        <input type="text" v-model="add_info" />
      </label>

      <fieldset class="fieldset">
        <legend>{{ 'Type'|t }}</legend>
        <div class="expanded button-group">
          <button :class="type === 'person' ? 'button' : 'button hollow'" disabled>
            <i class="icon icon-user"></i>
            {{ 'Person'|t}}
          </button>
          <button :class="type === 'org' ? 'button' : 'button hollow'" disabled>
            <i class="icon icon-user-tie"></i>
            {{ 'Organization'|t}}
          </button>
        </div>

        <div v-if="type === 'person'">
          <label>
            {{ 'First name'|t }}
            <input type="text" v-model="first_name" required="required" />
          </label>

          <label>
            {{ 'Middle name'|t }}
            <input type="text" v-model="middle_name" />
          </label>

          <label>
            {{ 'Last name'|t }}
            <input type="text" v-model="last_name" required="required" />
          </label>

          <label>
            {{ 'Birth date'|t }}
            <input type="date" v-model="birth_date" required="required" />
          </label>

          <fieldset class="fieldset">
            <legend>{{ 'Address'|t }}</legend>

            <label>
              {{ 'Address'|t }}
              <input type="text" v-model="postal_address" required="required" />
            </label>

            <label>
              {{ 'Postal code'|t }}
              <input type="text" v-model="postal_code" required="required" />
            </label>
          </fieldset>

          <fieldset class="fieldset">
            <legend>{{ 'Passport'|t }}</legend>

            <label>
              {{ 'ID'|t }}
              <input type="text" v-model="passport_id" required="required" />
            </label>

            <label>
              {{ 'Series'|t }}
              <input type="text" v-model="passport_series" required="required" />
            </label>

            <label>
              {{ 'Issuing Organization'|t }}
              <input type="text" v-model="passport_iss_org" required="required" />
            </label>

            <label>
              {{ 'Issue Date'|t }}
              <input type="date" v-model="passport_iss_date" required="required" />
            </label>
          </fieldset>
        </div>

        <div v-if="type === 'org'">
          <label>
            {{ 'Organization name'|t }}
            <input type="text" v-model="org_name" required="required" />
          </label>

          <label>
            {{ 'Telephone'|t }}
            <input type="tel" v-model="org_tel" required="required" />
          </label>

          <label>
            {{ 'E-mail'|t }}
            <input type="email" v-model="org_email" required="required" />
          </label>

          <label>
            {{ 'FOC'|t }}
            <input type="text" v-model="foc" required="required" />
          </label>

          <fieldset class="fieldset">
            <legend>{{ 'Legal address'|t }}</legend>

            <label>
              {{ 'Address'|t }}
              <input type="text" v-model="legal_address" required="required" />
            </label>

            <label>
              {{ 'Postal code'|t }}
              <input type="text" v-model="legal_postal_code" required="required" />
            </label>
          </fieldset>

          <fieldset class="fieldset">
            <legend>{{ 'Mailing address'|t }}</legend>

            <label>
              {{ 'Address'|t }}
              <input type="text" v-model="mailing_address" required="required" />
            </label>

            <label>
              {{ 'Postal code'|t }}
              <input type="text" v-model="mailing_postal_code" required="required" />
            </label>
          </fieldset>

        </div>
      </fieldset>

      <input type="submit" name="submit" :value="'Submit'|t" class="medium expanded success button" />
    </form>
  </div>
</template>

<script>
  import api from '@/api';
  import router from '@/routes';

  export default {
    name: 'UpdateForm',
    props: {
      ext_id: {
        type: String,
        required: true,
      },
    },
    created() {
      let self = this;
      api.viewExternalContact(
        {external_id: self.ext_id},
        data => {
          self.detail = data;
          this.contact_cid = data.contact_cid;
          this.external_id = data.external_id;
          this.object_type = data.object_type;
          this.vat = data.vat;
          this.add_info = data.add_info;
          this.type = 'person' in data && typeof data.person === 'object' ? "person" : "org";

          if (this.type === "person") {
            this.first_name = data.person.first_name;
            this.middle_name = data.person.middle_name;
            this.last_name = data.person.last_name;
            this.birth_date = data.person.birth_date;
            this.postal_address = data.person.address.address;
            this.postal_code = data.person.address.postal_code;
            this.passport_id = data.person.passport.id;
            this.passport_series = data.person.passport.series;
            this.passport_iss_date = data.person.passport.issue_date;
            this.passport_iss_org = data.person.passport.issue_org;
          } else {
            this.org_name = data.org.name;
            this.org_tel = data.org.telephone;
            this.org_email = data.org.email;
            this.foc = data.org.foc;
            this.legal_address = data.org.legal_address.address;
            this.legal_postal_code = data.org.legal_address.postal_code;
            this.mailing_address = data.org.mailing_address.address;
            this.mailing_postal_code = data.org.mailing_address.postal_code;
          }
        }
      )
    },
    data() {
      return {
        detail: {
          id: null,
        },
        external_id: null,
        contact_cid: null,
        object_type: null,
        vat: null,
        add_info: null,
        type: null,
        first_name: null,
        middle_name: null,
        last_name: null,
        birth_date: null,
        postal_address: null,
        postal_code: null,
        passport_id: null,
        passport_series: null,
        passport_iss_date: null,
        passport_iss_org: null,
        org_name: null,
        org_tel: null,
        org_email: null,
        foc: null,
        legal_address: null,
        legal_postal_code: null,
        mailing_address: null,
        mailing_postal_code: null,
      }
    },
    methods: {
      submitForm() {
        let request = {
          external_id: this.detail.external_id,
          object_type: parseInt(this.object_type),
          vat: this.vat,
          add_info: this.add_info,
        };

        if (this.type === 'person') {
          request.person = {
            first_name: this.first_name,
            middle_name: this.middle_name,
            last_name: this.last_name,
            birth_date: this.birth_date,
            address: {
              address: this.postal_address,
              postal_code: this.postal_code,
            },
            passport: {
              id: this.passport_id,
              series: this.passport_series,
              issue_date: this.passport_iss_date,
              issue_org: this.passport_iss_org,
            },
          }
        } else {
          request.org = {
            name: this.org_name,
            telephone: this.org_tel,
            email: this.org_email,
            foc: this.foc,
            legal_address: {
              address: this.legal_address,
              postal_code: this.legal_postal_code,
            },
            mailing_address: {
              address: this.mailing_address,
              postal_code: this.mailing_postal_code,
            },
          }
        }

        api.updateExternalContact(
          request,
          data => {
            this.$store.commit('messages/addMessage', {
              type: "status",
              message: "External contact %s has been updated.",
              args: [data.external_id]
            }, {root: true});
            router.push({name: 'external_contact.collection'});
          }
        );
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/external_contact/UpdateForm.vue